import TituloDescripcion from '@/components/elements/TituloDescripcion';
import TituloSeccionH2 from '@/components/elements/TituloSeccionH2';
import { black } from '@/constants/Colors';
import { LoginDatos, SetPassword } from '@/objects/User';
import { isPasswordValid } from '@/util/StringsUtil';
import { Card } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React from 'react';
import TextFieldCustom, { AutocompleteValues, InputTypes } from '@/components/elements/TextFieldCustom';
import Boton from '@/components/elements/Boton';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import { useServices } from '@/context/ServicesProvider';
import { mostrarAlerta } from '@/context/UtilsContext';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { subtitulo, textosPeque } from '@/constants/Dimens';
import Texto from '@/components/elements/Texto';
//Definimos los tipos de datos que va a recibir el componente en forma de interfaz

const PassUsuario: React.FC = () => {

    const { t } = useTranslation();

    const { usersQueries } = useServices();

    const [contra, setContra] = React.useState<string>("");
    const [repiteContra, setRepiteContra] = React.useState<string>("");

    function cambiarContra() {
        if (contra !== repiteContra) {
            mostrarAlerta({
                title: t('common:opciones.informacion'),
                content: t("menu:secciones.ajustes_perfil.contrasenas_no_coinciden"),
                showCancelButton: false,
            });
            return;
        }

        //Validar el password
        if (!isPasswordValid(contra)) {
            mostrarAlerta({
                title: t('common:opciones.informacion'),
                content: t("menu:secciones.ajustes_perfil.contrasena_no_valida") + " " + t("menu:secciones.ajustes_perfil.info_contrasenas"),
                showCancelButton: false,
            });
            return;
        }

        const datosUsuario: LoginDatos = cargarDatosUsuario()!;

        const setPassword: SetPassword = {
            idUser: datosUsuario.id_user,
            passw: contra,
        }

        usersQueries?.cambiarContra(setPassword).then((response) => {
            if (response.status == 200) {
                mostrarAlerta({
                    title: t('common:opciones.informacion'),
                    content: t("menu:secciones.ajustes_perfil.contrasena_cambiada_correctamente"),
                    showCancelButton: false,
                });
            }
        }).catch((error) => {
            console.log('Error en cambiarContra', error);
            if (error.response?.status === 400) {
                const detail_error = error.response?.data?.detail;

                if (detail_error === "Password must be.") {
                    mostrarAlerta({
                        title: t('common:opciones.error'),
                        content: t("menu:ajustes_perfil.info_contrasenas"),
                        showCancelButton: false,
                    });
                }
            }
        });
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: "100%" }}>
            <TituloSeccionH2 fontSize={subtitulo} texto={t("menu:secciones.ajustes_perfil.cambiar_contrasena")} />
            <div style={{ display: 'flex', flexDirection: 'column', width: "100%", alignItems: 'center', }}>
                <Card style={{
                    display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    alignItems: 'center', gap: '5px', padding: "20px", width: "100%",
                }}>

                    <div >
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start", marginBottom: "20px" }}>
                            <TituloDescripcion color={black} >{t('menu:secciones.ajustes_perfil.nueva_contra')}</TituloDescripcion>
                            <TextFieldCustom autocomplete={AutocompleteValues.NewPassword} inputType={InputTypes.Password} passwordShow label={t("menu:secciones.ajustes_perfil.nueva_contra")} value={contra} setValue={setContra} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start", marginBottom: "20px" }}>
                            <TituloDescripcion color={black} >{t('menu:secciones.ajustes_perfil.repite_contra')}</TituloDescripcion>
                            <TextFieldCustom autocomplete={AutocompleteValues.NewPassword} inputType={InputTypes.Password} passwordShow label={t("menu:secciones.ajustes_perfil.repite_contra")} value={repiteContra} setValue={setRepiteContra} />
                        </div>
                        <div>
                            <Texto fontSize={textosPeque}>{t("menu:secciones.ajustes_perfil.info_contrasenas")}</Texto>
                        </div>
                    </div>

                    <Boton fullWidth startIcon={<BrowserUpdatedIcon />} texto={t("menu:secciones.ajustes_perfil.cambiar_contrasena")} onClick={() => cambiarContra()} />

                </Card>
            </div>
        </section>
    );
}

export default PassUsuario;
